import PersonIcon from '@material-design-icons/svg/filled/person.svg?react';
import { Chip, EmptyState } from '../../../components/common/detailListParts';
import { Section } from '../../../components/common/detailParts';
import { TypedStatusBadge } from '../../../components/common/StatusBadge';
import { cn } from '../../../lib/utils';
import type { SuperPublisherTabProps } from '../types';

export function MembersTab({ data, formatDate }: SuperPublisherTabProps) {
  const { members, publisher } = data;

  return (
    <Section
      title="Members"
      trailing={
        <span className="text-xs tabular-nums text-neutral-500">
          {members.length}
        </span>
      }
    >
      {members.length === 0 ? (
        <EmptyState message="No members found" />
      ) : (
        <ul className="divide-y divide-white/5">
          {members.map((member) => {
            const isCurrent = member.id === publisher.id;
            return (
              <li
                key={member.id}
                className={cn(
                  '-mx-2 flex items-center gap-3 rounded-lg px-2 py-2.5',
                  isCurrent && 'bg-white/[0.02]',
                )}
              >
                <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-white/[0.04] ring-1 ring-white/10">
                  <PersonIcon className="size-5 fill-current text-neutral-500" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex min-w-0 flex-wrap items-center gap-2">
                    <span className="truncate text-sm font-medium text-white">
                      {member.user.fullName || member.user.email}
                    </span>
                    {member.isOwner && <Chip>Owner</Chip>}
                    {isCurrent && <Chip>This membership</Chip>}
                  </div>
                  <div className="mt-0.5 flex min-w-0 flex-wrap items-center gap-x-2 text-xs text-neutral-500">
                    <span className="truncate">{member.user.email}</span>
                    <span aria-hidden="true" className="text-neutral-700">
                      ·
                    </span>
                    <span>{member.role}</span>
                    <span aria-hidden="true" className="text-neutral-700">
                      ·
                    </span>
                    <span>
                      Joined {formatDate(member.acceptedAt ?? member.created)}
                    </span>
                  </div>
                </div>
                {member.kybStatus && (
                  <TypedStatusBadge
                    type="kyb"
                    status={member.kybStatus}
                    className="shrink-0"
                  />
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Section>
  );
}
